export default __webpack_public_path__ + "static/media/correct_guess.8b9ffd44.mp3";